import { Tabs } from 'react-tabs';

import hoistNonReactStatics from 'hoist-non-react-statics';

import { styled } from '../theme';

const TabsContainer = styled(Tabs)<{}>(({ theme }) => ({
    display: 'flex',
    flexFlow: 'column',
    flexShrink: 0,
    height: '100%',
    position: 'relative',
}));

TabsContainer.defaultProps = { selectedTabClassName: 'active' };

export default hoistNonReactStatics(TabsContainer, Tabs);
